import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="36" viewBox="0 0 34 36">
    <g fill="none" fillRule="evenodd" stroke="#3A00FF" strokeLinecap="square" strokeWidth="2">
      <path d="M1.5 1.531l31 32.938M32.5 1.531l-31 32.938" />
    </g>
  </svg>
);
